import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section">{`This action adds a payment to the `}<a parentName="p" {...{
          "href": "/api/../api/projects/orders#paymentinfo"
        }}>{`PaymentInfo`}</a>{`. The payment must not be assigned to another Order or active Cart yet.`}</p>
      <ul parentName="section">
        <li parentName="ul"><inlineCode parentName="li">{`action`}</inlineCode>{` - String - `}<inlineCode parentName="li">{`"addPayment"`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`payment`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/types#reference"
          }}>{`Reference`}</a>{` to a `}<a parentName="li" {...{
            "href": "/api/../api/projects/payments"
          }}>{`Payment`}</a></li>
      </ul>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      